// extracted by mini-css-extract-plugin
export default {"container":"modal_full_screen_content-module__container--2XJXm"};